import React from 'react'
import Guncelleniyor from '../components/Guncelleniyor'

const UOfis = () => {
  return (
  <Guncelleniyor/>
  
  )
}

export default UOfis